const login = '/login';
const error = '/error';
const program = 'program';
const dashboard = 'dashboard';
const performanceDashboard = 'performance_dashboard';
const payoutInitialization = 'payout_initialization';
const masterUpload = 'master_file_upload';
const inputFileUpload = 'input_file_upload';
const inputFileDownload = 'input_file_download';
const masterFileDownload = 'master_file_download';
const myTask = 'my_task';
const unificationHistory = 'unification_history';
const payoutHistory = 'payout_history';
const profile = '/profile';
const accounting = 'accounting';
const chartMapping = 'chart_mapping';
const dashboardChartMapping = 'dashboard_chart_mapping';
const chart = 'chart';
const overview = 'overview';
const runSimulation = 'run_simulation';
const viewSimulation = 'view_simulation';
const ruleDetails = 'rule_details';
const dataSync = 'data_sync';
const syncManagement = 'sync_management';
const syncHistory = 'sync_history';
const reviewer = 'reviewer';
const configTask = 'configTask';
const allTasklistDashboardView = 'allTasklistDashboardView';
const teamLeadDashboard = 'teamlead_dashboard';
const targetSetting = 'target_setting';
const historialReport = 'historial_report';
const userPerformanceReport = 'user_performance_report';
const targetOverride = 'target_override';
const raiseQuery = 'raise_query';
const contractCancellationUpload = 'contract_cancellation_upload';
const teamMemberPerformance = 'team_member_performance';
const needToPay = 'need_to_pay';
const uploadUtr = 'upload_utr';
const payoutAdmin = 'payout_admin';
const configReport = 'config_report';
const configReportChange = 'config_report_change';
const payoutReport = 'payout_report';
const noDuesCertificate = 'no_dues_certificate';
const cashAndCoupons = 'cash_and_coupons';
const couponConfirmation = 'coupon_confirmation';
const hold = 'hold';
const release = 'release';
const holdReleaseTaskConfig = 'hold_release_task_config';
const taskConfiguration = 'task_config';
const contest = 'contest';
const contestInitialization = 'contest_initialization';
const contestHistory = 'contest_history';
const dataCorrection = 'data_correction';
const inputFileDataCorrection = 'transaction_source_data_correction';
const masterFileDataCorrection = 'master_source_data_correction';
const triggerClawback = 'trigger_clawback';
const recalculation = 'recalculation_query';
const recalcUpload = 'recalc_upload';
const recalcCalculate = 'recalc_calculate';
const queryReport = 'query_report';
const invoiceReport = 'invoice_report';

const routeName = {
  runSimulation,
  viewSimulation,
  dashboard,
  performanceDashboard,
  login,
  error,
  program,
  payoutInitialization,
  masterUpload,
  inputFileUpload,
  inputFileDownload,
  masterFileDownload,
  myTask,
  unificationHistory,
  payoutHistory,
  profile,
  accounting,
  chartMapping,
  dashboardChartMapping,
  chart,
  overview,
  ruleDetails,
  syncManagement,
  syncHistory,
  dataSync,
  reviewer,
  configTask,
  allTasklistDashboardView,
  teamLeadDashboard,
  targetSetting,
  historialReport,
  userPerformanceReport,
  targetOverride,
  raiseQuery,
  contractCancellationUpload,
  teamMemberPerformance,
  needToPay,
  uploadUtr,
  payoutAdmin,
  payoutReport,
  noDuesCertificate,
  cashAndCoupons,
  couponConfirmation,
  hold,
  release,
  holdReleaseTaskConfig,
  taskConfiguration,
  contest,
  contestInitialization,
  contestHistory,
  dataCorrection,
  inputFileDataCorrection,
  masterFileDataCorrection,
  triggerClawback,
  recalculation,
  configReport,
  configReportChange,
  recalcUpload,
  recalcCalculate,
  queryReport,
  invoiceReport,
};

export default routeName;
